import { useState, useEffect, useRef, memo } from 'react'

import { availableOn, NUMBER_FORMATTERS } from '../../utils'
import { EMPTY_LINES } from '../../constants'
import { User, AddressCard, Pen } from '../../assets/icons'
import { CustomTooltip, Input } from '../ui_new'
const VariableTextInput = ({ fieldVariable, handle, repeatableIds, repetitionIndices, val, linesAdded, isHandleLocked, onAgencyModalOpen, onNotariesModalOpen, locked, sectionIndex, label, onValueChange, tooltip, hideTooltip }) => {
  const { variable, type, idx} = fieldVariable
  tooltip = hideTooltip ? '' : (tooltip || fieldVariable.tooltip)
  let classes = "tooltip-wrapper doc-variable-el"
  if(availableOn(['development']) && (variable === 'manufacturers_name' || variable === 'co_na_customers_lastname')) {
    classes += ' doc-variable-el--with-icon'
  }

  const [value, setValue] = useState(val)

  useEffect(() => {
    const formattedValue = (value) => {
      if(type === 'number') {
        if(parseFloat(value) < Number.MAX_SAFE_INTEGER) {
          // only parse if the value is less than MAX_SAFE_INTEGER to avoid precision issues
          value = parseFloat(value)
        }
      }
      let val = value
      const formatters = handle.substring(1, handle.length - 1).split(':').slice(1).filter(f => NUMBER_FORMATTERS[f])
      
      for(let i = 0; i < formatters.length; i++) {
        const f = formatters[i]
        if(NUMBER_FORMATTERS[f]) {
          val = NUMBER_FORMATTERS[f](val)

        }
      }
      return val
    }
    setValue(formattedValue(val))
  }, [val, type, handle])

  const formattedValue = (value) => {
    if(type === 'number') {
      if(parseFloat(value) < Number.MAX_SAFE_INTEGER) {
        // only parse if the value is less than MAX_SAFE_INTEGER to avoid precision issues
        value = parseFloat(value)
      }
    }
    let val = value
    const formatters = handle.substring(1, handle.length - 1).split(':').slice(1).filter(f => NUMBER_FORMATTERS[f])
    
    for(let i = 0; i < formatters.length; i++) {
      const f = formatters[i]
      if(NUMBER_FORMATTERS[f]) {
        val = NUMBER_FORMATTERS[f](val)

      }
    }
    return val
  }

  const isHandleFormatterLocked = () => {
    const formatters = handle.substring(1, handle.length - 1).split(':').slice(1)
    for(let f of formatters) {
      if(NUMBER_FORMATTERS[f]) {
        return true
      }
    }
    return false
  }

  const handleBlur = () => {
    if(value !== val && onValueChange) {
      onValueChange(formattedValue(value))
    }
  }


  return (
    <div className={classes} data-id={`${idx}${repeatableIds?.length > 0 ? `-${repeatableIds.map((repId, repIdIndex) => `${repId}-${repetitionIndices?.[repIdIndex]}`).join('-')}` : ''}`}>
      <div style={{padding: '5px 0'}}>
        <TextInput
          value={value}
          variable={variable}
          locked={locked || isHandleLocked(handle) || isHandleFormatterLocked()}
          type={(type === 'number' && typeof formattedValue(value) === 'string') ? 'string' : type}
          onValueChange={(val) => setValue(val)}
          onBlur={handleBlur}
          tooltip={tooltip}
          linesAdded={linesAdded}
          label={label} />
      </div>
      {availableOn(['development']) && variable === 'manufacturers_name' && (
        <CustomTooltip content="Changer les coordonnées de l'agence">
          <span className="icon" onClick={onAgencyModalOpen}><AddressCard /></span>
        </CustomTooltip>
      )}
      {availableOn(['development']) && variable === 'co_na_customers_lastname' && (
        <CustomTooltip content="Annuaire des notaires">
          <span className="icon" onClick={onNotariesModalOpen}><User /></span>
        </CustomTooltip>
      )}
    </div>
  )
}

// Text input component
export const TextInput = ({ value, variable, locked, onValueChange, type, tooltip, linesAdded = false, onBlur, label }) => {
  if(typeof value !== 'string' && value !== null && value !== undefined) {
    value = String(value)
  }
  const spanEl = useRef()
  let add = 0;
  let textInputClass = 'doc-variable-el__span'
  if(type === 'number') {
    textInputClass += ' doc-variable-el__span--number'
    add = 56
  }
  const [style, setStyle] = useState(value 
    ? { width: `${Math.max(((spanEl.current?.offsetWidth || 0) + add), 140)}px` }
    : { maxWidth: '100% !important' })

  useEffect(() => {
    let add =  type === 'number' ? 56 : 0;

    setStyle(value 
      ? { width: `${Math.max(((spanEl.current?.offsetWidth || 0) + add), 140)}px` }
      : { maxWidth: '100% !important' }
    )
  }, [value, type, tooltip])
  
  return (
    <>
      <span ref={spanEl} className={textInputClass}>{value}</span>
      <Input
        label={label}
        disabled={locked} 
        id={variable} 
        value={value || ''} 
        type={type} 
        editMode 
        onChange={(e) => onValueChange(e.target.value) } 
        className={value ? 'not-empty' : ''}
        tooltip={tooltip}
        inputStyle={style}
        linesAdded={linesAdded}
        onBlur={onBlur}
        placeholder={linesAdded ? (type === 'number' ? EMPTY_LINES.number : EMPTY_LINES.string) : ' - '}
      /> 
    </>
  )
}

export default memo(VariableTextInput)